import { withFormik } from 'formik';
import React from 'react';
import './DynamicForm.css';
import { mapPropsToValues, renderForm } from './renderer';
import { DFData, DFormState, DFValues } from './types';
import { noop } from './util';
import { validationSchema } from './validator';

export interface Props {
  data: DFData;
  debugInfo?: boolean;
  modalDOM?: HTMLDivElement;
  validateOnLoad?: boolean; // defaults to true
  yupSchema?: any;
  autoComplete?: 'on' | 'off';
  onChange?: (nextState: DFormState, prevState?: DFormState) => void;
  hideReqMsg?: boolean;
  reqMsg?: string;
}

const handleSubmit = noop;
const DynamicForm = withFormik<Props, DFValues>({
  mapPropsToValues,
  validationSchema,
  handleSubmit,
  isInitialValid
})(props => {
  return <div className="crc-dynamic-form">{renderForm(props)}</div>;
});

function isInitialValid(props: any) {
  return validationSchema(props).isValidSync(props.initialValues);
}

export default DynamicForm;
